import { render, staticRenderFns } from "./addType.vue?vue&type=template&id=55edb0a3&"
import script from "./addType.vue?vue&type=script&lang=js&"
export * from "./addType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports